import '../../Shared/js/SpeedTest';

(function () {
    'use strict';

    function main() {
        var controller = {
            init: function () {
                WhistleOut.SpeedTest.init(wo$('body'));
            }
        };

        WhistleOut.initWidget = controller.init;
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
